<template>
    <div class="entries-list-item">
        <div class="edit-container">
            <input
                @focus="inputOnClickHandler"
                :placeholder="$t('chatbotv2.title')"
                class="title-input"
                v-model="entry.value"
            />
            <div class="content-input-wrapper">
                <input
                    @focus="inputOnClickHandler"
                    @blur="synonymInputBlurHandler"
                    :placeholder="$t('chatbotv2.synonyms')"
                    class="content-input"
                    @keydown.enter="addSynonym"
                    v-model="synonymsVmodel"
                    :autofocus="true"
                />
                <div class="synonyms" v-if="open">
                    <a-tag
                        v-for="item in entry.synonyms"
                        :key="item.value"
                        class="synonym-tag"
                        closable
                        @close="deleteSynonym(item.value)"
                        >{{ item.value }}
                    </a-tag>
                </div>
            </div>
            <div class="actions" v-if="open">
                <div class="icon-container" @click="cancelOnClickHandler">
                    <md-icon class="close-icon">close</md-icon>
                </div>
                <div @click="updateEntry" class="icon-container">
                    <md-icon class="apply-icon">done</md-icon>
                </div>
            </div>
        </div>
        <div class="delete-entry" :style="open && { display: 'none' }" @click="deleteEntry">
            <md-icon>delete</md-icon>
        </div>
    </div>
</template>
<script>
import SynonymItem from "../../components/SynonymItem";

export default {
    name: "EntriesListItem",
    props: ["initialData", "otherEntryNames", "open", "onOpened", "onClosed"],
    components: {
        SynonymItem,
    },
    data() {
        return {
            synonymText: "",
            entry: {
                value: this.initialData.value,
                synonyms: this.initialData.synonyms,
            },
        };
    },
    methods: {
        addSynonym() {
            const isNotUnique = this.entry.synonyms.some((synonym) => synonym.value == this.synonymText);
            if (isNotUnique) {
                return this.$emit("error", this.$t("chatbotv2.synonymMustBeUnique"));
            }
            this.entry.synonyms.push({ value: this.synonymText });
            this.synonymText = "";
            this.updateEntry(false);
        },
        synonymInputBlurHandler() {
            if (this.synonymText.length > 0) {
                this.synonymText = "";
            }
        },
        deleteSynonym(synonym) {
            this.entry.synonyms = this.entry.synonyms.filter((item) => synonym !== item.value);
        },
        updateEntry(autoClose = true) {
            const isUnique = !this.otherEntryNames.includes(this.entry.value);
            if (this.entry.value.length == 0 || this.entry.synonyms.length < 1) {
                return this.$emit("error", this.$t("chatbotv2.emptyError"));
            }
            if (!isUnique) {
                return this.$emit("error", this.$t("chatbotv2.entryNamesMustBeUnique"));
                return;
            }
            this.$emit("update-entry", this.entry);

            if (autoClose) this.onClosed();
        },
        deleteEntry() {
            this.onClosed();
            this.$emit("delete-entry", this.entry.value || "");
        },
        inputOnClickHandler() {
            this.onOpened();
        },
        cancelOnClickHandler() {
            this.onClosed();
            this.entry.value = this.initialData.value;
            this.entry.synonyms = this.initialData.synonyms;
        },
    },
    computed: {
        stringSynonyms: function () {
            const synonymValue = this.entry.synonyms.map((synonym) => synonym.value);
            return synonymValue.join(", ");
        },
        synonymsVmodel: {
            get() {
                if (this.open) {
                    return this.synonymText;
                }
                return this.stringSynonyms;
            },
            set(newValue) {
                this.synonymText = newValue;
            },
        },
    },
    mounted() {},
    watch: {
        initialData(newValue) {
            if (newValue) {
                this.entry.value = this.initialData.value;
                this.entry.synonyms = this.initialData.synonyms;
            }
        },
    },
};
</script>
<style lang="scss">
.entries-list-item {
    display: flex;
    align-items: center;
    color: #516173;

    &:not(:last-child) {
        margin-bottom: 30px;
    }

    .edit-container {
        display: flex;
        align-items: flex-start;

        input {
            line-height: 31px;
            font-size: 24px;
            color: #22272d;
            border: none;
            font-weight: 300;
            border-bottom: 1px solid #9ba6b3;
            background-color: transparent;
            outline: none;
            padding: 8px 0px;
            transition: border-color 200ms;

            &::placeholder {
                font-weight: 300;
            }
        }

        .title-input {
            width: 255px;
        }

        .content-input-wrapper {
            max-width: 515px;
            width: 515px;

            .content-input {
                width: 100%;
                margin: 0 15px;
            }

            .synonyms {
                .synonym-tag {
                    background: #008aff;
                    border-radius: 5px;
                    margin: 2px 0.5px;
                    padding: 5px 10px;
                    line-height: 25px;
                    color: white;
                    font-size: 15px;

                    i {
                        color: white;
                        font-size: 15px;
                        margin: 0;
                        margin-left: 4px;
                    }
                }
            }
        }

        .actions {
            display: flex;
            justify-content: center;
            align-items: center;

            .icon-container {
                z-index: 2;

                .close-icon {
                    color: #22272d;
                }

                .apply-icon {
                    color: #008aff;
                    cursor: pointer;
                }
            }
        }
    }

    .delete-entry {
        margin-left: 34px;
        margin-top: 22px;
        opacity: 0;

        i {
            color: #9ba6b3;
            font-size: 24px;
        }
    }

    &:hover {
        .delete-entry {
            opacity: 1;
        }
    }
}
</style>
